// PRODUCT DESCRIPTION READ MORE BUTTON JS START
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".product_readmore_description").forEach(function (wrapper) {
    const fullHTML = wrapper.innerHTML;
    const limit = 130;

    function truncateHTMLWithReadMore(html, limit) {
      let count = 0;
      const container = document.createElement("div");
      container.innerHTML = html;
      let lastTextNode = null;

      function walk(node) {
        if (count >= limit) {
          node.remove();
          return;
        }

        if (node.nodeType === Node.TEXT_NODE) {
          if (count + node.nodeValue.length > limit) {
            node.nodeValue = node.nodeValue.substring(0, limit - count);
            count = limit;
          } else {
            count += node.nodeValue.length;
          }
          lastTextNode = node;
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          Array.from(node.childNodes).forEach(walk);
        }
      }

      Array.from(container.childNodes).forEach(walk);

      if (lastTextNode) {
        lastTextNode.nodeValue += "...";
        const readMore = document.createElement("span");
        readMore.className = "toggle-readmore";
        readMore.innerHTML = "<strong> Read More</strong>";
        lastTextNode.after(readMore);
      }

      return container.innerHTML;
    }

    const truncatedHTML = truncateHTMLWithReadMore(fullHTML, limit);
    wrapper.innerHTML = truncatedHTML;

    wrapper.addEventListener("click", function (e) {
      if (!e.target.closest(".toggle-readmore")) return;

      const toggle = e.target.closest(".toggle-readmore");

      if (toggle.textContent.includes("Read More")) {
        wrapper.innerHTML =
          fullHTML +
          '<span class="toggle-readmore"><strong> Read Less</strong></span>';
      } else {
        wrapper.innerHTML = truncatedHTML;
      }
    });
  });
});
// PRODUCT DESCRIPTION READ MORE BUTTON JS END

// PRODUCT DELIVERY TIME JS START
// today order and delivery from today to 3 day after
function parseDeliveryTime(input) {
  const match = input.match(/(\d+)\s*(day|days|hour|hours|)/i);
  if (!match) return { value: 0, unit: 'hours' };
  const value = parseInt(match[1]);
  const unit = match[2].toLowerCase();
  if (!unit || unit.startsWith('hour')) {
    return { value, unit: 'hours' };
  } else if (unit.startsWith('day')) {
    return { value, unit: 'days' };
  }
  return { value: 0, unit: 'hours' };
}
function calculateDeliveryDate(timeInput) {
  const { value, unit } = parseDeliveryTime(timeInput);
  const orderDate = new Date();
  const hoursToAdd = unit === 'days' ? value * 24 : value;
  const deliveryDate = new Date(orderDate.getTime() + (hoursToAdd * 60 * 60 * 1000));
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const dayName = days[deliveryDate.getDay()];
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const month = months[deliveryDate.getMonth()];
  const date = deliveryDate.getDate();
  return `${dayName}, ${month} ${date}${getOrdinalSuffix(date)}`;
}
function getOrdinalSuffix(day) {
  if (day > 3 && day < 21) return 'th';
  switch (day % 10) {
    case 1: return 'st';
    case 2: return 'nd';
    case 3: return 'rd';
    default: return 'th';
  }
}
// call the calculateDelivery function if found
let deliveryTimeInput = document.querySelector('.product_delivery_set');
if(deliveryTimeInput){
  let dataTimeValue = deliveryTimeInput.getAttribute('data-time');
  let resultTime = calculateDeliveryDate(dataTimeValue);
  deliveryTimeInput.innerHTML = resultTime;
}
// PRODUCT DELIVERY TIME JS END

document.addEventListener('DOMContentLoaded', function () {
  // Run only on new product template
  //if (!document.body.classList.contains('template-new-product')) return;

  // Select all sd-option elements
  const options = document.querySelectorAll('.sd-options .sd-option');

  options.forEach(option => {
    option.addEventListener('click', function () {
      // Remove 'active' class from all options
      options.forEach(opt => opt.classList.remove('active'));

      // Add 'active' class to the clicked option
      this.classList.add('active');

      // Get data attributes
      const sellingPlan = this.getAttribute('data-selling-plan');
      const price = this.getAttribute('data-price');
      console.log("Clicked sellingPlan -->", sellingPlan);

      const productBuyBlock = document.querySelector('.product_buybtn_block');
      if (productBuyBlock) {
        const slsContainers = productBuyBlock.querySelectorAll('.sls-purchase-options-container .sls-option-container');

        let targetContainer;

        if (sellingPlan) {
          // sellingPlan exists → activate container with data-selling-plan-group="0"
          targetContainer = productBuyBlock.querySelector('.sls-purchase-options-container .sls-option-container[data-selling-plan-group="0"]');
        } else {
          // sellingPlan blank → activate first container
          targetContainer = slsContainers[0];
        }

        if (targetContainer) {
          // Remove active from all containers
          slsContainers.forEach(c => c.classList.remove('sls-active'));

          // Add active to target container
          targetContainer.classList.add('sls-active');

          // Uncheck all radios first
          slsContainers.forEach(c => {
            const radio = c.querySelector('input.sls-option[type="radio"]');
            if (radio) radio.checked = false;
          });

          // Check the radio input inside the active container
          const radioInput = targetContainer.querySelector('input.sls-option[type="radio"]');
          if (radioInput) radioInput.checked = true;

          // ----- Handle <select> for selling plan intervals -----
          if (sellingPlan) {
            const select = targetContainer.querySelector('select.sls-select');
            if (select) {
              // Set the select value to the sellingPlan if it exists in options
              const optionToSelect = select.querySelector(`option[value="${sellingPlan}"]`);
              if (optionToSelect) {
                select.value = sellingPlan;
                // Trigger change event if needed
                select.dispatchEvent(new Event('change'));
              }
            }
          }

          console.log("Active container -->", targetContainer);
        }
      }

      console.log('Clicked option:');
      console.log('Selling Plan ID:', sellingPlan);
      console.log('Price:', price);
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  // Run only on new product template
  // if (!document.body.classList.contains('template-new-product')) return;

  // Select all sticky-cart forms
  const forms = document.querySelectorAll('.sticky-cart__form');
  console.log('sticky product add to cart 0');
  forms.forEach(form => {
    // Get the visible button inside this form
    const addButton = form.querySelector('.product-form--submit');
    console.log('sticky product add to cart 1');
    if (addButton) {
      addButton.addEventListener('click', function(e) {
        console.log('sticky product add to cart 2');
        e.preventDefault(); // prevent default form submit if needed
        this.classList.add('loading');

        // Select all parent divs that contain the button
        const blocks = document.querySelector('.product_buybtn_block');
        const button = blocks.querySelector('.shopify-product-form .product-form__buttons button[type="submit"]');

        if (button) {
          // Trigger the actual button click
          button.click();
          console.log('sticky product add to cart 2');
        }
        // remove loading after delay
        setTimeout(() => {
          this.classList.remove('loading');
        }, 1500); // ⏱️ 1.5 seconds (change as needed)
      });
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  // Run only on new product template
  if (
  !document.body.classList.contains('template-new-product') &&
  !document.body.classList.contains('template-subscriptions')
) return;

  const intervalId = setInterval(function () {
    const productbuybtnblock = document.querySelector('.product_buybtn_block');
    const descBlock = productbuybtnblock.querySelector('.sls-selling-plan-description-content');
    console.log("descBlock foubnd");
    // Check div exists
    if (!descBlock) return;

    // Prevent duplicate append
    if (descBlock.querySelector('ul')) return;

    // Append HTML
    descBlock.insertAdjacentHTML(
      'beforeend',
      `
      <ul class="subscription_points">
        <li><svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.6463 3.96983L8.64715 0.137784C8.48351 0.0474055 8.29961 0 8.11267 0C7.92572 0 7.74183 0.0474055 7.57819 0.137784L0.579022 3.96983C0.403888 4.06565 0.257737 4.2068 0.15587 4.37849C0.0540032 4.55018 0.000167716 4.7461 0 4.94573V12.5526C0.000167716 12.7522 0.0540032 12.9481 0.15587 13.1198C0.257737 13.2915 0.403888 13.4326 0.579022 13.5285L7.57819 17.3605C7.74188 17.4507 7.92575 17.4981 8.11267 17.4981C8.29958 17.4981 8.48346 17.4507 8.64715 17.3605L15.6463 13.5285C15.8215 13.4326 15.9676 13.2915 16.0695 13.1198C16.1713 12.9481 16.2252 12.7522 16.2253 12.5526V4.94573C16.2252 4.7461 16.1713 4.55018 16.0695 4.37849C15.9676 4.2068 15.8215 4.06565 15.6463 3.96983ZM8.03313 0.974503C8.05654 0.961694 8.0828 0.95498 8.10949 0.95498C8.13617 0.95498 8.16243 0.961694 8.18584 0.974503L14.8343 4.61327L12.1348 6.09026L5.41242 2.41092L8.03313 0.974503ZM7.63545 16.3051L1.03397 12.6917C1.00957 12.6777 0.989358 12.6574 0.975384 12.6329C0.96141 12.6084 0.95418 12.5807 0.954432 12.5526V5.46113L7.63545 9.11978V16.3051ZM1.39108 4.61327L4.41902 2.95495L11.1406 6.63428L8.11267 8.29102L1.39108 4.61327ZM15.2709 12.5526C15.2712 12.5807 15.2639 12.6084 15.25 12.6329C15.236 12.6574 15.2158 12.6777 15.1914 12.6917L8.58988 16.3051V9.11819L11.4532 7.55054V10.658C11.4532 10.7846 11.5035 10.906 11.593 10.9955C11.6824 11.0849 11.8038 11.1352 11.9304 11.1352C12.057 11.1352 12.1783 11.0849 12.2678 10.9955C12.3573 10.906 12.4076 10.7846 12.4076 10.658V7.02878L15.2709 5.46113V12.5526Z" fill="#312B33"/></svg> <span>FREE delivery on all orders every 30 days</span></li>
        <li><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.625 0C6.91914 0 5.25158 0.505847 3.83321 1.45357C2.41484 2.4013 1.30935 3.74834 0.656542 5.32435C0.00373693 6.90037 -0.167067 8.63456 0.165731 10.3076C0.498528 11.9807 1.31998 13.5176 2.52621 14.7238C3.73243 15.93 5.26926 16.7515 6.94235 17.0843C8.61543 17.4171 10.3496 17.2463 11.9256 16.5935C13.5017 15.9406 14.8487 14.8352 15.7964 13.4168C16.7442 11.9984 17.25 10.3309 17.25 8.625C17.2473 6.33833 16.3377 4.14609 14.7208 2.52917C13.1039 0.91225 10.9117 0.00268546 8.625 0ZM8.625 16.2353C7.11983 16.2353 5.64846 15.789 4.39695 14.9527C3.14544 14.1165 2.17001 12.9279 1.59401 11.5373C1.018 10.1467 0.867294 8.61655 1.16094 7.1403C1.45458 5.66405 2.17939 4.30803 3.24371 3.24371C4.30803 2.17939 5.66405 1.45458 7.14031 1.16093C8.61656 0.86729 10.1467 1.018 11.5373 1.594C12.9279 2.17001 14.1165 3.14544 14.9527 4.39694C15.789 5.64845 16.2353 7.11982 16.2353 8.625C16.2331 10.6427 15.4305 12.5771 14.0038 14.0038C12.5771 15.4305 10.6427 16.233 8.625 16.2353ZM7.10294 5.91912V11.3309C7.10294 11.4654 7.04949 11.5945 6.95434 11.6896C6.85919 11.7848 6.73015 11.8382 6.59559 11.8382C6.46103 11.8382 6.33198 11.7848 6.23684 11.6896C6.14169 11.5945 6.08824 11.4654 6.08824 11.3309V5.91912C6.08824 5.78456 6.14169 5.65551 6.23684 5.56036C6.33198 5.46522 6.46103 5.41176 6.59559 5.41176C6.73015 5.41176 6.85919 5.46522 6.95434 5.56036C7.04949 5.65551 7.10294 5.78456 7.10294 5.91912ZM11.1618 5.91912V11.3309C11.1618 11.4654 11.1083 11.5945 11.0132 11.6896C10.918 11.7848 10.789 11.8382 10.6544 11.8382C10.5199 11.8382 10.3908 11.7848 10.2957 11.6896C10.2005 11.5945 10.1471 11.4654 10.1471 11.3309V5.91912C10.1471 5.78456 10.2005 5.65551 10.2957 5.56036C10.3908 5.46522 10.5199 5.41176 10.6544 5.41176C10.789 5.41176 10.918 5.46522 11.0132 5.56036C11.1083 5.65551 11.1618 5.78456 11.1618 5.91912Z" fill="#312B33"/></svg><span>Pause, update frequency or cancel anytime</span></li>
        <li><svg width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.11824 10.4545L0 5.49896L1.27956 4.26006L5.11824 7.97675L13.3568 0L14.6364 1.2389L5.11824 10.4545Z" fill="#312B33"/></svg><span>Guaranteed delivery during sell-outs</span></li>
      </ul>
      `
    );
    // Stop interval once added
    //clearInterval(intervalId);
  }, 300);
});

document.addEventListener('DOMContentLoaded', function () {
  // Run only on new product template
  if (
  !document.body.classList.contains('template-new-product') &&
  !document.body.classList.contains('template-subscriptions')
) return;

  const intervalId = setInterval(function () {

    const labels = document.querySelectorAll('.sls-selling-plan-group-name');

    if (!labels.length) return;

    labels.forEach(label => {
      const badge = label.querySelector('.sls-savings-badge');

      if (label.textContent.includes('Subscribe & Save Up To')) {
        // Update only text, keep badge
        label.childNodes.forEach(node => {
          if (node.nodeType === Node.TEXT_NODE) {
            node.textContent = 'Subscribe ';
          }
        });
      }
    });

    clearInterval(intervalId);

  }, 300);
});

document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.sls-select').forEach(function (select) {

    select.addEventListener('change', function () {

      const container = this.closest('.sls-purchase-options-container');
      if (!container) return;

      const savingsBadge = container.querySelector('.sls-savings-badge');
      const priceBadgeSale = document.querySelector('.price__badge-sale');
      if (!priceBadgeSale) return;

      if (savingsBadge && savingsBadge.textContent.trim() !== '') {
        const badgeText = savingsBadge.textContent.trim();
        priceBadgeSale.textContent = badgeText;
        priceBadgeSale.style.display = 'inline-block';
      } else {
        priceBadgeSale.textContent = '';
        priceBadgeSale.style.display = 'none';
      }
    });

  });

});

// document.querySelectorAll('input.sls-option').forEach(radio => {
//   radio.addEventListener('click', function () {
//     console.log("radio--->", radio)
//     const priceBadgeSale = document.querySelector('.price__badge-sale');
//     if (!priceBadgeSale) return;

//     // ONE TIME
//     if (this.dataset.type === 'one_time') {
//       priceBadgeSale.textContent = '';
//       priceBadgeSale.style.display = 'none';
//       return;
//     }

//     // SUBSCRIPTION
//     if (this.dataset.type === 'subscription') {
//       const container = this.closest('.sls-purchase-options-container');
//       if (!container) return;

//       const savingsBadge = container.querySelector('.sls-savings-badge');

//       if (savingsBadge && savingsBadge.textContent.trim()) {
//         priceBadgeSale.textContent = savingsBadge.textContent.trim();
//         priceBadgeSale.style.display = 'inline-block';
//       }
//     }
//   });
// });

document.addEventListener('click', function (e) {
  const option = e.target.closest('.sls-option-container');
  if (!option) return;

  // active plan container
  setTimeout(function(){
    const activePlan = option.closest('.sls-purchase-options-container');

    // currently selected plan id
    const sellingPlanInput = activePlan.querySelector(
      'input.sls-option:checked'
    );
    var subscriptionType='';
    if (sellingPlanInput) {
      subscriptionType =  sellingPlanInput.getAttribute('data-type');
    }

    // example custom logic
    if(subscriptionType!=""){
      handleSubscriptionChange(subscriptionType);
    }
  },100);
});
function handleSubscriptionChange(type) {
  var mainObj = document.querySelector('.product__info-wrapper');
  if(type=='subscription'){
    mainObj.querySelector('.price__badge-sale').style.display='block';
    var offTextObj = document.querySelector('.sls-purchase-options-container');
    var getOffBadge = offTextObj.querySelector('.sls-savings-badge').textContent.trim();

    mainObj.querySelector('.price__badge-sale').textContent=getOffBadge;
  }else{
    mainObj.querySelector('.price__badge-sale').style.display='none';
  }
}

document.addEventListener('change', function (e) {
  if (!e.target.classList.contains('sls-select')) return;

  const select = e.target;
  setTimeout(function(){
    const container = select.closest('.sls-purchase-options-container');
    if (!container) return;

    // selected option text
    const selectedText = select.selectedOptions[0]?.text.trim() || '';

    // extract number
    const intervalNumber = selectedText.match(/\d+/)?.[0];
    if (!intervalNumber) return;

    console.log('intervalNumber:', intervalNumber);

    // target span correctly
    const numberSpan = container.querySelector(
      '.subscription_points li span'
    );

    if (numberSpan) {
      numberSpan.innerText = numberSpan.innerText.replace(/\d+/, intervalNumber);
    }
  },300);
});

//SUBSCIRPTION WISE FREE PRIDUCT ADDED ON CART FREE START
document.addEventListener('click', function (e) {
  const option = e.target.closest(
    '.sls-purchase-options-container, .sls-selling-plan-group-first-line'
  );

  if (!option) return;

  // Wait for Shopify to update the DOM
  setTimeout(readSellingPlanState, 50);
});

document.addEventListener('DOMContentLoaded', function () {
  var setInterId = setInterval(function(){
    if(document.querySelector(
      '.sls-selling-plan-group-first-line .sls-option')!=null){
        readSellingPlanState();
        clearInterval(setInterId);
      }
  });
});

function readSellingPlanState() {
  // Native Shopify selling plan radio
  const sellingPlanInput = document.querySelector(
    '.sls-selling-plan-group-first-line .sls-option:checked'
  );

  // 🔥 Your logic here
  var selectedSubscription = sellingPlanInput.value;
  var objFreeProduct = document.querySelector('.freegift_bundle_block');
  console.log("objFreeProduct",objFreeProduct);
  if (selectedSubscription=='0') {
    createFreeGiftInputsFromHidden();
    switchToSubscription();
    if(objFreeProduct!=null){
      objFreeProduct.style.display='block';
    }
  } else {
    removeFreeGiftInputs();
    switchToOneTime();
    if(objFreeProduct!=null){
      objFreeProduct.style.display='none';
    }
  }
}

function normalizeQuantityInput(isSubscription) {
  const form = document.querySelector('.product__info-wrapper .shopify-product-form');
  if (!form) return;

  // Find ANY quantity input
  let qty = form.querySelector('input[name="quantity"], input[name="quantity[]"]');

  if (!qty) {
    qty = document.createElement('input');
    qty.type = 'hidden';
    form.appendChild(qty);
  }

  qty.name = isSubscription ? 'quantity[]' : 'quantity';
  qty.value = '1';

  // Remove duplicates (very important)
  form.querySelectorAll('input[name="quantity"], input[name="quantity[]"]').forEach((el, i) => {
    if (i > 0) el.remove();
  });
}

function switchToSubscription() {
  const mainId = document.querySelector(
    '.product__info-wrapper .shopify-product-form input[data-main-product]'
  );

  if (mainId) mainId.name = 'id[]';

  normalizeQuantityInput(true);
}

function switchToOneTime() {
  const mainId = document.querySelector(
    '.product__info-wrapper .shopify-product-form input[data-main-product]'
  );

  if (mainId) mainId.name = 'id';

  normalizeQuantityInput(false);
}

function createFreeGiftInputsFromHidden() {
  const source = document.querySelector('input[name="free_gift_variant_ids"]');
  const form = document.querySelector('.product__info-wrapper .shopify-product-form');

  if (!source || !form) return;

  const ids = source.value.split(',').map(id => id.trim()).filter(Boolean);
  if (!ids.length) return;

  // Prevent duplicates
  if (form.querySelector('[data-free-gift]')) return;

  ids.forEach(id => {
    const idInput = document.createElement('input');
    idInput.type = 'hidden';
    idInput.name = 'id[]';
    idInput.value = id;
    idInput.setAttribute('data-free-gift', '');

    const qtyInput = document.createElement('input');
    qtyInput.type = 'hidden';
    qtyInput.name = 'quantity[]';
    qtyInput.value = '1';
    qtyInput.setAttribute('data-free-gift', '');

    form.appendChild(idInput);
    form.appendChild(qtyInput);
  });

  // Optional property (if needed)
  const prop = document.createElement('input');
  prop.type = 'hidden';
  prop.name = 'properties[_free_gift]';
  prop.value = ids.join(',');
  prop.setAttribute('data-free-gift', '');
  form.appendChild(prop);
}


function removeFreeGiftInputs() {
  document
    .querySelectorAll('[data-free-gift]')
    .forEach(el => el.remove());
}


//SUBSCIRPTION WISE FREE PRIDUCT ADDED ON CART FREE END

document.querySelector('.full_ingredients').addEventListener('click', function(e) {
  e.preventDefault();

  const details = document.querySelector('.accordion.ingredients details');
  const summary = details?.querySelector('summary');

  if (details && summary && !details.hasAttribute('open')) {
    summary.click();
  }

  const headerHeight = document.querySelector('header').offsetHeight;

  const y = details.getBoundingClientRect().top + window.pageYOffset - headerHeight - 10;

  window.scrollTo({
    top: y,
    behavior: 'smooth'
  });
});


